var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0259 12.8474L17.5948 16.4163L16.4163 17.5948L12.8474 14.0259C11.5642 15.0526 9.93675 15.6667 8.16675 15.6667C4.02675 15.6667 0.666748 12.3067 0.666748 8.16675C0.666748 4.02675 4.02675 0.666748 8.16675 0.666748C12.3067 0.666748 15.6667 4.02675 15.6667 8.16675C15.6667 9.93675 15.0526 11.5642 14.0259 12.8474ZM12.354 12.2291C13.373 11.1789 14.0001 9.74642 14.0001 8.16675C14.0001 4.94383 11.3897 2.33341 8.16675 2.33341C4.94383 2.33341 2.33341 4.94383 2.33341 8.16675C2.33341 11.3897 4.94383 14.0001 8.16675 14.0001C9.74642 14.0001 11.1789 13.373 12.2291 12.354L12.354 12.2291Z",
    fill: "#93A1BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGlass);
export default __webpack_public_path__ + "static/media/SearchGlass.7d59d5a5cc850e8d7964724453f1348d.svg";
export { ForwardRef as ReactComponent };